<script lang="ts">
  interface Props {
    label?: string;
    value: number;
    min: number;
    max: number;
    step?: number;
    unit?: string;
    digits?: number;
    onchange: (v: number) => void;
  }
  const {
    label,
    value,
    min,
    max,
    step = 1,
    unit = '',
    digits,
    onchange,
  }: Props = $props();

  function display(v: number): string {
    if (digits != null) return v.toFixed(digits);
    if (step >= 1) return Math.round(v).toString();
    if (step >= 0.1) return v.toFixed(1);
    return v.toFixed(2);
  }
</script>

<label class="slider">
  {#if label}<span class="label">{label}</span>{/if}
  <div class="row">
    <input
      type="range"
      {min}
      {max}
      {step}
      {value}
      oninput={(e) =>
        onchange(parseFloat((e.target as HTMLInputElement).value))}
    />
    <span class="value">{display(value)}{unit}</span>
  </div>
</label>

<style>
  .slider {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 12px;
    color: var(--text-dim);
  }
  .row {
    display: grid;
    grid-template-columns: 1fr 56px;
    gap: 6px;
    align-items: center;
  }
  input[type='range'] {
    width: 100%;
    accent-color: var(--accent);
  }
  .value {
    font-family: var(--font-mono);
    font-size: 11px;
    color: var(--text);
    text-align: right;
  }
</style>
